module.exports = __webpack_public_path__ + "media/images/sign_up_background_med-2b21bb1e07814e1f625d2a981f8277fa.png";